// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Tuo ruokalista alustalta {{platform}}',
    copy: 'Kopioi ruokalista ravintolasta {{restaurant}}',
    data: 'Luo Amigon lukema menu',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Luo {{categories}} ja {{dishes}}',
    from: {
      file: 'Amigo luki tämän tiedostostasi',
      chat: 'Amigo luki tämän keskustelustamme',
    },
    summary: 'Luo {{categories}} ja {{dishes}}. Tarkista jokainen annos hintoineen alla olevasta luettelosta.',
    price: 'Hinta',
    tax_category: 'Verokategoria',
    no_price: 'Ei hintaa vielä',
    default_tax: 'Oma vakioverokantasi',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Luodaan {{categories}} ja {{dishes}}…',
    done: 'Menu on luotu: {{categories}}, {{dishes}} ja {{option_groups}} ovat ravintolan {{restaurant}} menussa',
    done_plain: 'Menu on luotu',
  },
  waiting: 'Odottaa hyväksyntää',
  labels: {
    from: 'Lähde',
    to: 'Kohde',
    menu: 'Ruokalista',
    brings_over: 'Tuo mukanaan',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Amigon lukema ruokalista · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, sen ainoa toimipaikka',
    brand_one: '{{name}}-brändin menu, sen ainoa toimipiste',
    brand_other: '{{name}}-brändin ruokalista, kaikki {{count}} toimipaikkaa',
  },
  menu: {
    empty: 'Tyhjä, joten tästä tulee ruokalista',
    adds: 'Lisätään nykyiseen ruokalistaan ({{size}}). Samannimiset annokset päivitetään; mitään ei poisteta.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} kategoria',
    categories_other: '{{count}} kategoriaa',
    dishes_one: '{{count}} annos',
    dishes_other: '{{count}} annosta',
    option_groups_one: '{{count}} lisävalintaryhmä',
    option_groups_other: '{{count}} lisävalintaryhmää',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Kaikki sellaisenaan',
    categories: 'kategoriat',
    dishes: 'annokset',
    descriptions: 'kuvaukset',
    prices: 'hinnat',
    option_groups: 'valintaryhmät',
    photos: 'kuvat',
    where: {
      allergens_nutrition: 'allergeenit ja ravintoarvot, jos {{platform}} tarjoaa ne',
      allergens: 'allergeenit, jos {{platform}} tarjoaa ne',
      nutrition: 'ravintoarvot, jos {{platform}} tarjoaa ne',
    },
  },
  not_live: '{{restaurant}} ei ole vielä käytössä: vieraat näkevät ruokalistan kauppalinkissä, mutta eivät voi tilata.',
  buttons: {
    import: 'Tuo',
    copy: 'Kopioi',
    cancel: 'Peruuta',
  },
  hint: 'Tai vastaa alla muuttaaksesi jotain.',
  action_failed: 'Se ei onnistunut, joten mikään ei muuttunut. Yritä hetken kuluttua uudelleen.',
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Tämä tuonti on jo käynnissä. Amigo ilmoittaa tässä, kun se on valmis.',
    already_applying: 'Tätä otetaan käyttöön juuri nyt. Odota hetki, kunnes se on valmis.',
  },
  importing: {
    title: {
      import: 'Tuodaan alustalta {{platform}}…',
      copy: 'Kopioidaan ravintolasta {{restaurant}}…',
    },
    started: 'Aloitettu {{time}}',
    queued: 'Käynnistetään…',
    hint: 'Tämä voi kestää muutaman minuutin. Voit sulkea paneelin tai jatkaa työskentelyä; julkaisen tuloksen tähän.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'Tuonti alustalta {{platform}} on valmis: {{categories}}, {{dishes}} ja {{option_groups}} ovat ravintolan {{restaurant}} ruokalistalla',
      copy: 'Kopiointi on valmis: {{categories}}, {{dishes}} ja {{option_groups}} ovat ruokalistalla',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'Tuonti alustalta {{platform}} on valmis',
      copy: 'Kopiointi on valmis',
    },
    finished: 'Valmistui {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Avaa {{page}}',
  },
  failed: {
    title: {
      import: 'Tuonti epäonnistui: {{reason}}',
      copy: 'Kopiointi epäonnistui: {{reason}}',
    },
    title_plain: {
      import: 'Tuonti epäonnistui',
      copy: 'Kopiointi epäonnistui',
    },
    nothing: {
      import: 'Mitään ei tuotu.',
      copy: 'Mitään ei kopioitu.',
    },
    what_to_try: 'Kokeile tätä:',
    retry: 'Yritä uudelleen',
    reasons: {
      listing_not_found: {
        title: 'listausta ei löytynyt',
        text: 'Alustalla {{platform}} ei ole ravintolaa tässä linkissä. Mitään ei tuotu.',
        try: 'Avaa linkki selaimessa ja tarkista, että se näyttää ravintolan ruokalistan, ja lähetä se sitten uudelleen.',
      },
      listing_not_supported: {
        title: 'listausta ei tueta',
        text: 'Tämä on alustan {{platform}} ketjusivu, ei yksittäisen ravintolan ruokalista, joten en voi tuoda sitä. Mitään ei tuotu.',
        try: 'Lähetä linkki ravintolan omalle ruokalistasivulle alustalla {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} epäonnistui',
        text: '{{platform}} ei vastannut, joten mitään ei tuotu.',
        try: 'Yritä uudelleen muutaman minuutin kuluttua.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'kopiointi epäonnistui',
        text: 'Kopiointi ei valmistunut, joten mitään ei kopioitu.',
        try: 'Yritä uudelleen muutaman minuutin kuluttua.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'valuutta ei täsmää',
        text: 'Listaus on valuutassa {{listing}}, mutta {{restaurant}} käyttää valuuttaa {{currency}}. Mitään ei tuotu.',
        try: 'Lähetä listaus valuutassa {{currency}} tai tarkista ravintolan valuutta ensin kohdasta {{page}}.',
        text_other: 'Listaus on eri valuutassa kuin ravintolan {{restaurant}}. Mitään ei tuotu.',
        try_other: 'Lähetä listaus ravintolan valuutassa tai tarkista sen valuutta ensin kohdasta {{page}}.',
      },
      link_paused: {
        title: 'linkki keskeytetty',
        text: 'Tämä linkki epäonnistui 3 kertaa peräkkäin, joten tuonnit siitä on keskeytetty kunnes {{time}}. Mitään ei tuotu.',
        text_no_until:
          'Tämä linkki epäonnistui 3 kertaa peräkkäin, joten tuonnit siitä on toistaiseksi keskeytetty. Mitään ei tuotu.',
        try: 'Lähetä linkki toiselta alustalta tai kopioi ruokalista toisesta ravintolasta.',
      },
    },
  },
  stopped: {
    title: 'Pysäytetty: {{restaurant}} otettiin käyttöön',
    nothing: {
      import: 'Mitään ei tuotu',
      copy: 'Mitään ei kopioitu',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Peruutettu',
    expired: 'Vanhentunut',
    replaced: 'Korvattu',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Hyväksytty.',
    cancelled: 'Peruutettu.',
    retried: 'Yritetty uudelleen.',
  },
};
